import React from "react";
import { StationDeviceTemplate } from "themes/administration/user/components"

function StationDevice(props) {
    return <StationDeviceTemplate {...props} />;
}

export default StationDevice;